import axios, {AxiosResponse} from 'axios'
import {ApiResponse, PaginatedResponse} from '../../../shared/models/ApiModels'
import { IBranchStatisticsModel, IGeneralStatusModel, IReturnedCarModel } from './DashboardModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const RENDTED_CAR_COUNT_URL = `${API_URL}api/v1/dashboard/rented-vehicles/count`
export const RENDTED_CAR_URL = `${API_URL}api/v1/dashboard/rented-vehicles`
export const AVAILABLE_CAR_COUNT_URL = `${API_URL}api/v1/dashboard/available-vehicles/count`
export const AVAILABLE_CAR_URL = `${API_URL}api/v1/dashboard/available-vehicles`
export const RESERVED_CAR_COUNT_URL = `${API_URL}api/v1/dashboard/reserved-vehicles/count`
export const RESERVED_CAR_URL = `${API_URL}api/v1/dashboard/reserved-vehicles`
export const SERVICE_CAR_COUNT_URL = `${API_URL}api/v1/dashboard/service-vehicles/count`

export const LATE_RETURN_CAR_URL = `${API_URL}api/v1/dashboard/late-returns`
export const TODAY_RETURN_CAR_URL = `${API_URL}api/v1/dashboard/return-today`
export const TODAY_RETURNED_CAR_URL = `${API_URL}api/v1/dashboard/returned-today`
export const TOMORROW_RETURN_CAR_URL = `${API_URL}api/v1/dashboard/return-tomorrow`
export const LATE_DEPARTURE_CAR_URL = `${API_URL}api/v1/dashboard/late-departure`
export const TODAY_DEPARTURE_CAR_URL = `${API_URL}api/v1/dashboard/departure-today`
export const TODAY_DEPARTURED_CAR_URL = `${API_URL}api/v1/dashboard/departured-today`
export const TOMORROW_DEPARTURE_CAR_URL = `${API_URL}api/v1/dashboard/departure-tomorrow`
export const BRANCH_STATISTICS_URL = `${API_URL}api/v1/dashboard/branch-statistics`
export const GENERAL_STATUS_URL = `${API_URL}api/v1/dashboard/general-status`

export function getRentedCarCount(): Promise<AxiosResponse<ApiResponse<number>>> {
  return axios.get(RENDTED_CAR_COUNT_URL);
}

export function getRentedCars(page = 0, size = 10): Promise<AxiosResponse<ApiResponse<PaginatedResponse<IReturnedCarModel>>>> {
  return axios.get(RENDTED_CAR_URL, {
    params: { page, size }
  });
}

export function getAvailableCarCount(): Promise<AxiosResponse<ApiResponse<number>>> {
  return axios.get(AVAILABLE_CAR_COUNT_URL);
}

export function getAvailableCars(page = 0, size = 10): Promise<AxiosResponse<ApiResponse<PaginatedResponse<IReturnedCarModel>>>> {
  return axios.get(AVAILABLE_CAR_URL, {
    params: { page, size }
  });
}

export function getReservedCarCount(): Promise<AxiosResponse<ApiResponse<number>>> {
  return axios.get(RESERVED_CAR_COUNT_URL);
}

export function getReservedCars(page = 0, size = 10): Promise<AxiosResponse<ApiResponse<PaginatedResponse<IReturnedCarModel>>>> {
  return axios.get(RESERVED_CAR_URL, {
    params: { page, size }
  });
}

export function getServiceCarCount(): Promise<AxiosResponse<ApiResponse<number>>> {
  return axios.get(SERVICE_CAR_COUNT_URL);
}

export function getLateReturnCars(page = 0, size = 10): Promise<AxiosResponse<ApiResponse<PaginatedResponse<IReturnedCarModel>>>> {
  return axios.get(LATE_RETURN_CAR_URL, {
    params: { page, size }
  });
}

export function getTodayReturnCars(page = 0, size = 10): Promise<AxiosResponse<ApiResponse<PaginatedResponse<IReturnedCarModel>>>> {
  return axios.get(TODAY_RETURN_CAR_URL, {
    params: { page, size }
  });
}

export function getTodayReturnedCars(page = 0, size = 10): Promise<AxiosResponse<ApiResponse<PaginatedResponse<IReturnedCarModel>>>> {
  return axios.get(TODAY_RETURNED_CAR_URL, {
    params: { page, size }
  });
}

export function getTomorrowReturnCars(page = 0, size = 10): Promise<AxiosResponse<ApiResponse<PaginatedResponse<IReturnedCarModel>>>> {
  return axios.get(TOMORROW_RETURN_CAR_URL, {
    params: { page, size }
  });
}

export function getLateDepartureCars(page = 0, size = 10): Promise<AxiosResponse<ApiResponse<PaginatedResponse<IReturnedCarModel>>>> {
  return axios.get(LATE_DEPARTURE_CAR_URL, {
    params: { page, size }
  });
}

export function getTodayDepartureCars(page = 0, size = 10): Promise<AxiosResponse<ApiResponse<PaginatedResponse<IReturnedCarModel>>>> {
  return axios.get(TODAY_DEPARTURE_CAR_URL, {
    params: { page, size }
  });
}

export function getTodayDeparturedCars(page = 0, size = 10): Promise<AxiosResponse<ApiResponse<PaginatedResponse<IReturnedCarModel>>>> {
  return axios.get(TODAY_DEPARTURED_CAR_URL, {
    params: { page, size }
  });
}

export function getTomorrowDepartureCars(page = 0, size = 10): Promise<AxiosResponse<ApiResponse<PaginatedResponse<IReturnedCarModel>>>> {
  return axios.get(TOMORROW_DEPARTURE_CAR_URL, {
    params: { page, size }
  });
}

export function getBranchStatistics(): Promise<AxiosResponse<ApiResponse<IBranchStatisticsModel[]>>> {
  return axios.get(BRANCH_STATISTICS_URL);
}

export function getGeneralStatus(): Promise<AxiosResponse<ApiResponse<IGeneralStatusModel>>> {
  return axios.get(GENERAL_STATUS_URL);
}